<mat-nav-list>
  <h3 class="subheader">
    Signaalkaarten
    @if (!signaalkaartAntwoordenPage.isEmpty()) {
      <zah-sort-button
        [sortOrder]="initialPageRequest.getSortOrder()"
        (sortOrderChange)="onSortOrderChange($event)">
      </zah-sort-button>
    }
  </h3>
  @for (signaalkaartAntwoord of signaalkaartAntwoordenPage.getItems(); track signaalkaartAntwoord; let isLast = $last) {
    <mat-list-item (click)="onSignaalkaartAntwoordClick(signaalkaartAntwoord)">
      <div matListItemAvatar [ngClass]="getSignaalkaart(signaalkaartAntwoord.getSignaalkaartId(), signaalkaartAntwoord.getSignaalkaartVersie()).getIcoon()"></div>
      <div matListItemTitle>{{getSignaalkaart(signaalkaartAntwoord.getSignaalkaartId(), signaalkaartAntwoord.getSignaalkaartVersie()).getTitel()}}
        <span>({{getSignaalkaart(signaalkaartAntwoord.getSignaalkaartId(), signaalkaartAntwoord.getSignaalkaartVersie()).getCategorie()}})</span>
      </div>
      <div matListItemLine class="mat-small">{{signaalkaartAntwoord.getCreatieTijdstip() | date:'d MMMM yyyy' }}</div>
    </mat-list-item>
    @if (!isLast) {
      <mat-divider></mat-divider>
    }
  }
  @if (signaalkaartAntwoordenPage.isEmpty()) {
    <mat-list-item
      class="no-list-item-highlight"
      disableRipple>
      <div matListItemTitle>Geen signaalkaarten gevonden</div>
    </mat-list-item>
  }
</mat-nav-list>
@if (!signaalkaartAntwoordenPage.isEmpty()) {
  <zah-paginator
    [currentPage]="signaalkaartAntwoordenPage"
    [pageSize]="initialPageRequest.getPageSize()"
    (pageSizeChange)="onPageSizeChange($event)"
    (pageChange)="onPageChange($event)">
  </zah-paginator>
}
